import React from 'react';
import { BUTTON_TYPES, components as Core, useTranslation } from '../../../../core';
import { css, colors, spacing, StyleSheet } from '../../../../../styles';

/**
 * Renders the modal action buttons.
 *
 * @param {object} props
 * @param {boolean} props.hasChanges
 * @param {boolean} props.isUpdatingCompany
 * @param {Function} props.onClose
 * @param {Function} props.onSave
 */
export const CompanyDetailsFooter = ({
    hasChanges = false,
    isUpdatingCompany = false,
    onClose = null,
    onSave = null
}) => {
    const { t } = useTranslation();

    return (
        <div className={css(styles.footer)}>
            <Core.Button
                label={t('cancel')}
                onPress={onClose}
                type={BUTTON_TYPES.blueOutline}
            />
            <Core.Button
                label={t('companies.details.saveChanges')}
                onPress={onSave}
                isLoading={isUpdatingCompany}
                isDisabled={!hasChanges || isUpdatingCompany}
                className={styles.saveButton}
            />
        </div>
    );
};

const styles = StyleSheet.create({
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: spacing.s1,
        marginTop: spacing.s4,
        paddingTop: spacing.s4,
        borderTop: `1px solid ${colors.greyLight}`
    },
    saveButton: {
        '&.ant-btn-primary[disabled]': {
            color: `${colors.blackOpacity} !important`,
            backgroundColor: `${colors.background} !important`,
            borderColor: `${colors.border} !important`,
            boxShadow: 'none !important'
        }
    }
});
